import { AuthPort, AuthCredentials } from '../ports/AuthPort';
import { IdentityRepository } from '../ports/IdentityRepository';
import { UserSession } from '../entities/UserSession';

export class LoginUseCase {
  constructor(
    private authPort: AuthPort,
    private identityRepo: IdentityRepository
  ) {}

  async execute(credentials: AuthCredentials): Promise<UserSession> {
    // 1. Authenticate
    const authUser = await this.authPort.login(credentials);

    // 2. Resolve Profile & Role
    const profile = await this.identityRepo.getProfile(authUser.uid);
    const role = await this.identityRepo.getRole(authUser.uid);

    // 3. Handle specific role data (e.g. staff store info)
    let storeId: string | undefined;
    let merchantId: string | undefined;

    if (role.isStaff()) {
      const assignment = await this.identityRepo.getStaffAssignment(authUser.uid);
      if (assignment) {
        storeId = assignment.storeId;
        merchantId = assignment.ownerId;
      }
    } else if (role.isOwner()) {
      merchantId = authUser.uid;
    }

    // 4. Build Session
    return new UserSession({
      uid: authUser.uid,
      email: authUser.email,
      role: role,
      mustChangePassword: profile?.mustChangePassword || false,
      storeId,
      merchantId,
      displayName: profile?.fullName || authUser.metadata?.full_name
    });
  }
}
